import Cookies from 'js-cookie'
import store from '~/store'

export function setupStoreCache() {
  window.addEventListener('beforeunload', () => {
    Cookies.set('tenantId', store.state.tenantId || 1000)
    if (store.state.errorMessage) {
      Cookies.set('errorMessage', store.state.errorMessage)
    }
  })
}
